import React from 'react';

export const securePagesConfig = [
	{
		auth: [
			'service_provider',
			'admin',
			'organization_manager',
			'marketplace_manager',
			'staff',
			'limited_staff',
			'GFE',
			'network_manager',
			'network_group_staff',
			'patient',
		],
		routes: [
			{
				path: '/secure',
				component: React.memo(() => {
					React.useEffect(() => {
						globalThis.location.href = 'https://patients.healthmedocs.com/sign-in';
					}, []);
					return null;
				}),
			},
		],
	},
];
